import { render, staticRenderFns } from "./panguSpin.vue?vue&type=template&id=322ddbe6"
import script from "./panguSpin.vue?vue&type=script&lang=js"
export * from "./panguSpin.vue?vue&type=script&lang=js"
import style0 from "./panguSpin.vue?vue&type=style&index=0&id=322ddbe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports